import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { heroStats } from '../mockData';
import { ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-white via-gray-50 to-white pt-16" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, SF Pro Text, sans-serif' }}>
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, rgb(0 122 255) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        {/* Main Heading - Apple style */}
        <h1
          className={`text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-semibold text-gray-900 mb-6 tracking-tight transition-all duration-700 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
          style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif', letterSpacing: '-0.02em' }}
        >
          Innovative IT Solutions
          <br />
          <span className="bg-gradient-to-r from-blue-600 to-cyan-500 text-transparent bg-clip-text">
            for Modern Business
          </span>
        </h1>

        {/* Description */}
        <p
          className={`text-xl sm:text-2xl text-gray-600 mb-10 max-w-3xl mx-auto font-normal leading-relaxed transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
          style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}
        >
          Empowering businesses with cutting-edge enterprise networks, cloud infrastructure,
          and comprehensive IT services.
        </p>

        {/* CTA Buttons - Apple style */}
        <div
          className={`flex flex-col sm:flex-row gap-4 justify-center mb-16 transition-all duration-700 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <Link to="/services">
            <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-base rounded-full shadow-md hover:shadow-lg transition-all">
              Explore Services
            </Button>
          </Link>
          <Link to="/contact">
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-gray-300 text-gray-900 hover:bg-gray-50 px-8 py-6 text-base rounded-full transition-all"
            >
              Contact Us
            </Button>
          </Link>
        </div>

        {/* Stats Section */}
        <div
          className={`grid grid-cols-2 md:grid-cols-4 gap-6 transition-all duration-700 delay-400 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          {heroStats.map((stat, index) => (
            <div
              key={stat.id}
              className="p-6 rounded-2xl bg-white/50 backdrop-blur-sm border border-gray-200 hover:shadow-md transition-all"
            >
              <div className="text-4xl md:text-5xl font-semibold text-gray-900 mb-2" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif' }}>
                {stat.value}
              </div>
              <div className="text-sm text-gray-600" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-gray-400" size={32} />
      </div>
    </section>
  );
};

export default Hero;
